import { ReloadIcon } from "@/assets"
import { Button } from "@/ui/Button"

export const ButtonReload = () => (
  <Button
    icon={<ReloadIcon width={20} height={20} />}
    onClick={() => window.location.reload()}
  />
)
